import React, { FC, useEffect, useState } from 'react';
import clsx from 'clsx';
import { Toggle } from 'rsuite';
import { IModalWindow, ModalWindow } from '../modal/ModalWindow';
import { removeTwoFactorAuthentication } from '../../store/identyti/actions/users';
import { IUserData } from '../../store/identyti/identity-interfaces';

export interface IRemoveTwoFactorAuth {
	username: string,
	email: string,
}
export const UserListToggle: FC = (props:IUserData) => {
	const { twoFactorEnabled, userName, email } = props;
	const [loading, setLoading] = useState<boolean>(false);
	const [localTwoFactorEnabled, setLocalTwoFactorEnabled] = useState<boolean>(false);
	const [modalState, setModalState] = useState<IModalWindow>({
		isOpen: false
	});
	const closeModal = (): void => setModalState(prev => ({ ...prev, isOpen: false }));

	useEffect(() => {
		setLocalTwoFactorEnabled(Boolean(twoFactorEnabled));
	}, []);

	const handleConfirm = async (): Promise<void> => {
		try {
			setLoading(true);
			const body: IRemoveTwoFactorAuth = {
				username: userName,
				email: email
			};
			await removeTwoFactorAuthentication(body);
			setLocalTwoFactorEnabled(!localTwoFactorEnabled);
			closeModal();
			setLoading(false);
		} catch (e) {
			console.log(e);
			setLocalTwoFactorEnabled(localTwoFactorEnabled);
			closeModal();
			setLoading(false);
		}
	};

	const handleChange = async (): Promise<void> => {
		setModalState({
			isOpen: true,
			modalTitle: 'Remove two-factor authentication',
			modalText: 'Are you sure? Only user can activate two-factor authentication',
			minHeight: 100,
			onCancel: closeModal,
			onConfirm: handleConfirm,
			confirmButtonText: 'Confirm'
		});

	};
	return (
		<>
			<Toggle
				size="md"
				checked={localTwoFactorEnabled}
				className={clsx(localTwoFactorEnabled ? 'is-active' : '')}
				onChange={handleChange}
				disabled={loading || !twoFactorEnabled || !localTwoFactorEnabled}
			/>
			<ModalWindow
				{...modalState}
				onClose={closeModal}
			/>
		</>
	);
};
